export default __webpack_public_path__ + "static/media/home_launch.887aa26c.png";